import { NEWS_SEO_IT } from './news/news.it.seo';

import { SeoPartnerWeb } from 'libs/shared-lib/interfaces/seo/seo-partner-web';
import { ABOUT_US_SEO_IT } from './about-us/about-us.it.seo';
import { CHECKOUTS_SEO_IT } from './checkouts/checkouts.it.seo';
import { HOME_SEO_IT } from './home/home.it.seo';
import { LOCATIONS_SEO_IT } from './locations/locations.it.seo';
import { NOT_FOUND_SEO_IT } from './not-found/not-found.it.seo';
import { PROMOTION_NOT_AVAILABLE_SEO_IT } from './promotion-not-available/promotion-not-available.it.seo';
import { PROMOTIONS_SEO_IT } from './promotions/promotions.it.seo';
import { SERVICE_SEO_IT } from './service/service.it.seo';
import { SUB_DEALER_SEO_IT } from './sub-dealer/sub-dealer.it.seo';
import { VEHICLE_NOT_AVAILABLE_SEO_IT } from './vehicle-not-available/vehicle-not-available.it.seo';

export const PARTNER_WEB_SEO_IT: SeoPartnerWeb = {
    home: HOME_SEO_IT,
    checkouts: CHECKOUTS_SEO_IT,
    news: NEWS_SEO_IT,
    promotions: PROMOTIONS_SEO_IT,
    aboutUs: ABOUT_US_SEO_IT,
    service: SERVICE_SEO_IT,
    locations: LOCATIONS_SEO_IT,
    subDealer: SUB_DEALER_SEO_IT,
    notFound: NOT_FOUND_SEO_IT,
    vehicleNotAvailable: VEHICLE_NOT_AVAILABLE_SEO_IT,
    promotionNotAvailable: PROMOTION_NOT_AVAILABLE_SEO_IT,
};
